// @flow
import React from "react";
import { useSelector } from "react-redux";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";

export const processarPontualDiario = comGeradorDePeriodo((state, medidas) => {
  const edicaoMedida = getEdicaoMedida(state);
  const dataBase = getDataBaseSelecionadaAsString(state);
  const modoSeries = isModoSeries(state);

  if (modoSeries) {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  } else {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      periodicidade: edicaoMedida.periodicidade,
      ajusteDias: edicaoMedida.ajusteDias,
      dataBase: dataBase,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  }
});

const PontualDiario = () => {
  const modoSeries = useSelector(isModoSeries);

  return (
    <>
      <SelecaoPeriodo exibirPeriodicidade={false} />
      <div className="ConfiguracaoMedida__group">
        <div className="ConfiguracaoMedida__box">
          <SelecaoPeriodicidade />
        </div>

        <div className="ConfiguracaoMedida__box">
          <SelecaoAjusteDias />
        </div>
      </div>
      {!modoSeries && <SelecaoCasasDecimais />}
    </>
  );
};

export default PontualDiario;
